// /ia-report-print/:token — print-only page for a client Internal Audit report PDF (opened by the headless
// renderer, netlify/functions/render-ia-report-background.js). Sets window.__READY__ once drawn.
import React, { useEffect, useState } from 'react'
import { useParams } from 'react-router-dom'
import { supabase } from '../lib/supabase'
import IAReportDocument from '../components/IAReportDocument'

export default function IAReportPrint() {
  const { token } = useParams()
  const [data, setData] = useState(null)
  const [err, setErr] = useState('')

  useEffect(() => {
    supabase.rpc('get_ia_report_for_print', { p_token: token }).then(({ data, error }) => {
      // Tell the renderer it failed (never print an error page as if it were the report).
      if (error || !data) { setErr('Report not found.'); window.__IA_ERROR__ = (error && error.message) || 'Report not found'; return }
      setData(data)
    })
  }, [token])

  useEffect(() => {
    if (!data) return
    // Wait for images (logo / stamp) before telling the renderer to print.
    const imgs = Array.from(document.images)
    Promise.all(imgs.map(i => i.complete ? null : new Promise(r => { i.onload = r; i.onerror = r })))
      .then(() => { window.__READY__ = true })
  }, [data])

  if (err) return <div style={{ padding: 40 }}>{err}</div>
  if (!data) return null
  return (
    <div style={{ background: '#fff' }}>
      <style>{'@page { size: A4; } body { background: #fff !important; margin: 0; } * { -webkit-print-color-adjust: exact; print-color-adjust: exact; }'}</style>
      <IAReportDocument snapshot={data.snapshot} logos={data.logos} />
    </div>
  )
}
